<template lang="pug">
ul.nav
  li.item-link.level-menu
    router-link.parent(:to="href" v-if="href !== undefined && href !== '' ")
      .icon-header
        .fontawesome.text-gray
          i.fa.fa-chevron-left
      .text-header
        span {{title}}
    .board-img
      .icon-classes
        .img-classess
          img(:src="item.classes.thumbnail" v-if="item.classes && item.classes.thumbnail !== undefined  && item.classes.thumbnail !== null && item.classes.thumbnail.length > 0")
          img(src="../../assets/images/faces/ic_AvatarDefault@2x.png" v-else)
        .private-lock(v-if="item.classes && item.classes.private")
          i.fa.fa-lock
      .icon-function(v-if="$isMobile()" :class="[isPopover ? 'open-popover' : '']" @click="clickPopoverClass")
        i.material-icons.text-gray(style="cursor:pointer") more_horiz
        .box-popover
          span(v-if="item.status === 1" @click="onFlagDeleted(item)") Xoá yêu cầu
          span(v-if="item.status === 3" @click="onDeleted(item)") Xoá yêu cầu
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 1" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 2" @click="unPinPC(item, 1)") Bỏ ghim lớp học
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 2" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="copyLinkJoin(item)") Copy link tham gia
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="unPinPC(item, 1)") Bỏ ghim lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="copyLinkJoin(item)") Copy link tham gia
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="unPinPC(item, 2)") Ghim lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="onDeleted(item, false)") Rời lớp học
      .icon-function.and-hover(v-else)
        i.material-icons.text-gray(style="cursor:pointer") more_horiz
        .box-popover
          span(v-if="item.status === 1" @click="onFlagDeleted(item)") Xoá yêu cầu
          span(v-if="item.status === 3" @click="onDeleted(item)") Xoá yêu cầu
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 1" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 2" @click="unPinPC(item, 1)") Bỏ ghim lớp học
          span(v-if="item.status === 2 && item.classes.private && item.un_pin_class === 2" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="copyLinkJoin(item)") Copy link tham gia
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="unPinPC(item, 1)") Bỏ ghim lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 2" @click="onDeleted(item, false)") Rời lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="copyLinkJoin(item)") Copy link tham gia
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="unPinPC(item, 2)") Ghim lớp học
          span(v-if="item.status === 2 && !item.classes.private && item.un_pin_class === 1" @click="onDeleted(item, false)") Rời lớp học
      .clearfix
    .board-info
      .title-classes
        span(v-if="item.classes") {{item.classes.name}}
  item.level-menu-classes(:title="channel.name", :href='urlChannel(channel)' v-if="lstChannel && lstChannel.length > 0" v-for="(channel, index) in lstChannel" :key="index")
</template>

<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import item from '../Sidebar/item'
export default {
  components: {
    MdNotification,
    item
  },
  props: {
    icon: String,
    title: String,
    href: String,
    avatar: String
  },
  data() {
    return {
      item: [],
      lstChannel: [],
      isPopover: false,
      loader: null,
      classID: 0,
      pcID: 0,
      user: null,
      isActive: 0
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    urlChannel(item) {
      return '/classes-to-me/' + this.$mycontroller.doSanitizeTitle(item.name) + '?id=' + item.class.id
    },
    clickPopoverClass() {
      this.isPopover = !this.isPopover
    },
    url(title, clID) {
      let url = window.location.origin + '/' + this.$router.resolve({name: 'join_classes'}).href + this.$router.resolve({name: 'join_classes'}).route.name + '/'
      let seoUrl = url + clID + '-' + this.$mycontroller.doSanitizeTitle(title)
      return seoUrl
    },
    copyLinkJoin(item) {
      var url = this.url(item.classes.name, item.classes_id)
      const input = document.createElement('input')
      input.value = url
      document.body.appendChild(input)
      input.select()
      input.setSelectionRange(0, 99999)
      try {
        var successful = document.execCommand('copy')
        document.body.removeChild(input)
        if (successful) this.showNotification('Copy thành công', 'success', 'top', 'right', 2000)
        else this.showNotification('Không thể copy', 'warning', 'top', 'right', 2000)
      } catch (err) {
        this.showNotification('Không thể copy', 'warning', 'top', 'right', 2000)
      }
    },
    async checkExerciseUserExist($exerciseID, $userID, $classID) {
      var isExists = -1
      var objWhere = {
        exercise_id: {'_eq': $exerciseID},
        user_id: {'eq': $userID},
        class_id: {'_eq': $classID}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.CHECK_EXERCISE_USER_EXIST2),
        variables: {
          where: objWhere
        }
      })
      if (data && data.exercise_user.length > 0) {
        // nếu is_delete tai khoan bi xoa
        isExists = data.exercise_user[0].is_delete ? 2 : 1
      } else isExists = 0
      return isExists
    },
    async assignExerciseUser(exerciseIDs, userID, classID) {
      if (exerciseIDs !== null && exerciseIDs.length > 0) {
        for (let i = 0; i < exerciseIDs.length; i++) {
          var isExists = await this.checkExerciseUserExist(parseInt(exerciseIDs[i]), userID, classID)
          if (isExists === 2) {
            let objWhere = {
              exercise_id: {_eq: parseInt(exerciseIDs[i])},
              user_id: {_eq: userID},
              class_id: {_eq: classID}
            }
            let objInput = {
              is_delete: true,
              updated_by: this.$store.getters.user
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.UPDATE_EXERCISE_USER),
              variables: {objWhere: objWhere, objInput: objInput}
            }).catch((error) => {
              this.loader.hide()
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
              console.error(error.message)
            })
          }
        }
      }
    },
    onDeleted(item, isDeleted) {
      var text = isDeleted ? 'xoá yêu cầu' : 'rời lớp học'
      this.$modal.show('dialog', {
        title: 'Xác nhận',
        text: 'Bạn có chắc chắn ' + text + ' <b>' + item.classes.name + '</b> khỏi danh sách lớp học của mình không?',
        class: 'col-md-6 col-12 box-popup-confirm',
        buttons: [
          {
            title: 'Xác nhận',
            default: true,
            class: 'btn btn-primary confirm-delete-dialog',
            handler: async () => {
              if (isDeleted) this.deletedUserPC(item)
              else this.updateDeletedUserPC(item, true)
            }
          },
          {
            title: 'Hủy yêu cầu',
            class: 'btn btn-primary cancel-delete-dialog'
          }
        ]
      })
    },
    async deletedUserPC(item) {
      this.show()
      var objWhere = {
        pc_id: {_eq: item.pc_id},
        user_id: {_eq: item.user_id},
        classes_id: {_eq: item.classes_id}
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.DELETE_PC_USER),
        variables: {objWhere: objWhere},
        update: (store, { data: { delete_pc_user } }) => {
          if (delete_pc_user.affected_rows) {
            this.loader.hide()
            this.$modal.hide('dialog')
            this.$router.push({name: 'classes_to_me'})
          }
        }
      })
    },
    onFlagDeleted(item) {
      this.$modal.show('dialog', {
        title: 'Xác nhận',
        text: 'Bạn có chắc chắn xoá yêu cầu duyệt lớp học <b>' + item.classes.name + '</b> này không?',
        class: 'col-md-6 col-12 box-popup-confirm',
        buttons: [
          {
            title: 'Xác nhận',
            default: true,
            class: 'btn btn-primary confirm-delete-dialog',
            handler: async () => {
              this.updateDeletedUserPC(item, null)
            }
          },
          {
            title: 'Hủy yêu cầu',
            class: 'btn btn-primary cancel-delete-dialog'
          }
        ]
      })
    },
    async updateDeletedUserPC(item, type) {
      this.show()
      var objWhere = {
        pc_id: {_eq: item.pc_id},
        user_id: {_eq: item.user_id},
        classes_id: {_eq: item.classes_id}
      }
      var objInput = {
        un_pin: 1,
        is_delete: true
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_PC_USER_ALL),
        variables: {objWhere: objWhere, objInput: objInput},
        update: (store, { data: { update_pc_user } }) => {
          if (update_pc_user.affected_rows) {
            // assign bài tập cho user
            if (type && type !== null) this.assignExerciseUser(item.classes.exercise_ids, item.user_id, item.classes_id)
            this.loader.hide()
            this.$modal.hide('dialog')
            this.$router.push({name: 'classes_to_me'})
          }
        }
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
    },
    async unPinPC(item, unPin) {
      this.show()
      var objWhere = {
        pc_id: {_eq: item.pc_id},
        user_id: {_eq: item.user_id},
        classes_id: {_eq: item.classes_id}
      }
      var objInput = {
        un_pin_class: unPin
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_PC_USER_ALL),
        variables: {objWhere: objWhere, objInput: objInput},
        update: (store, { data: { update_pc_user } }) => {
          if (update_pc_user.affected_rows) {
            this.loader.hide()
            this.$modal.hide('dialog')
            this.item.un_pin_class = unPin
          }
        }
      }).catch((error) => {
        this.error = error.message
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error)
      })
    }
  },
  async mounted () {
    this.user = this.$store.getters
    if (this.$route.query.id !== null && !isNaN(this.$route.query.id) && this.$route.query.id > 0) {
      this.classID = Number(this.$route.query.id)
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_CLASSES_OF_PC),
        variables: {
          where: {
            id: {_eq: this.classID}
          }
        }
      })
      if (data.classes !== undefined && data.classes !== null && data.classes.length > 0) {
        this.pcID = data.classes[0].pc_id
        var variables = {
          where: {
            user_id: {'_eq': this.$store.getters.user},
            pc_id: {'_eq': this.pcID},
            classes_id: {'_eq': this.classID}
          }
        }
        await this.$apollo.query({
          query: gql(graphql.GET_CLASS_USER_JOIN_STUDENT),
          variables: variables
        }).then((response) => {
          if (response.data.pc_user !== undefined && response.data.pc_user !== null && response.data.pc_user.length > 0) {
            this.item = response.data.pc_user[0]
          }
        })
        await this.$apollo.query({
          query: gql(graphql.GET_CHANNEL),
          variables: {
            where: {
              classes_id: {'_eq': this.classID}
            },
            order_by: {
              private: 'desc',
              created_at: 'desc'
            }
          }
        }).then((response) => {
          this.lstChannel = response.data.channel
          if (this.lstChannel.length > 0) {
            var name = this.lstChannel[0].name
            this.$router.push({path: '/classes-to-me/' + this.$mycontroller.doSanitizeTitle(name), query: {id: this.classID}})
          }
        })
        if (this.item === null) this.$router.go(-1)
      } else this.$router.go(-1)
    } else this.$router.go(-1)
  }
}
</script>
<style lang="scss">
  .level-menu{
    a.parent{
      &.active{background: transparent !important; align-items: center}
      .text-header{color: #969FAD!important; font-weight: normal !important;}
    }
    .board-img{padding: 0 15px;
      .icon-classes{width: 64px; height: 64px; float: left; position: relative;
        .img-classess{ position: relative; width: 60px; height: 60px; display: inline-flex;  overflow: hidden; border-radius: 50%;
          img{max-width: 100%; height: auto;}
        }
        .private-lock{background: #FBF4D2 0% 0% no-repeat padding-box; border-radius: 50%; width: 16px; height: 16px; display: inline-block; padding: 2px 0; position: absolute; right: 10px; bottom: 3px;
          i{color: #4B2D15; font-size: 12px; display: block; float: none; margin: 0; line-height: initial; width: auto;}
        }
      }
    }
    .board-info{padding: 0 15px; margin: 15px 0;
      .title-classes{font-weight: bold; color: #343A40; font-size: 15px;}
    }
    .icon-function{float: right; position: relative; cursor: pointer;
      i.text-gray{margin: 0;}
      .box-popover{position: absolute; top: 20px; right: 0; left: auto; z-index: 1060; display: none; min-width: 150px; padding: 8px;  background: #F8F8F8 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; border-radius: 10px;
        span{display: block; font-size: 15px; color: #23180A; padding: 5px;}
      }
      &.open-popover{
        .box-popover{display: block;}
      }
      &.and-hover:hover{
        .box-popover{display: block;}
      }
    }
  }
  .level-menu-classes{
    .parent{
      &.active{background: #EAEAEA 0% 0% no-repeat padding-box !important;
        &:hover{background: #EAEAEA !important;}
        .text-header{ font-weight: inherit !important;  color: #343A40; font-size: 14px;}
      }
      &:hover{background: transparent !important;}
      .text-header{ color: #343A40; font-size: 14px;}
    }
  }
@media screen and (max-width: 1366px){
  
}
@media screen and (max-width: 1024px){
  
}
@media screen and (max-width: 991px){
  
}
@media screen and (max-width: 768px){
}
@media screen and (max-width: 640px){
  
}
@media screen and (max-width: 480px){
  
}
</style>




// WEBPACK FOOTER //
// itemSideBarLevel.vue?2f7aaa8c